import {
  Component,
  HostBinding,
  Input,
  ElementRef,
  NgZone,
  OnInit,
} from '@angular/core';
import { LinearLoaderStyles } from './linear-loader-styles';
import { AnimationService } from '../core/ui/animation.service';
import { styleVariables } from '../styles/variables';

@Component({
  selector: 'pg-linear-loader-message, grit-linear-loader-message',
  templateUrl: './pg-linear-loader-message.component.html',
  styleUrls: ['./pg-linear-loader-message.component.scss'],
  exportAs: 'pgLinearLoaderMessage, gritLinearLoaderMessage',
})
export class PgLinearLoaderMessageComponent implements OnInit {
  ngOnInit() {
    if (this._messageVisibilityState === 'hidden') {
      return this._animationService.animate({
        targets: this._elementRef.nativeElement,
        opacity: [1, 0],
        transform: [`translateY(16px)`, `translateY(0)`],
        duration: 0,
        easing: 0,
        fillMode: 'forwards',
        height: 0,
      });
    }
  }

  private beginAnimations = state => {
    if (state === 'hidden') {
      this.animateOut();
    } else if (state === 'visible') {
      this.animateIn();
    }
  };

  private animateIn() {
    const messageHeight = this._elementRef.nativeElement.children[0]
      .offsetHeight;
    // console.log(messageHeight)
    this._animationService.animate({
      targets: this._elementRef.nativeElement,
      opacity: [0, 1],
      transform: [`translateY(16px)`, `translateY(0)`],
      duration: styleVariables.transitionDurationLong,
      easing: styleVariables.transitionCurveAcceleration,
      fillMode: 'forwards',
      height: messageHeight,
    });
  }

  private animateOut() {
    this._animationService.animate({
      targets: this._elementRef.nativeElement,
      opacity: [1, 0],
      transform: [`translateY(0)`, `translateY(16px)`],
      duration: styleVariables.transitionDurationLong,
      easing: styleVariables.transitionCurveAcceleration,
      fillMode: 'forwards',
      delay: 0,
      height: 0,
    });
  }

  constructor(
    public _elementRef: ElementRef,
    private _ngZone: NgZone,
    private _animationService: AnimationService
  ) {}

  @Input() get messageVisibilityState(): string {
    return this._messageVisibilityState;
  }

  set messageVisibilityState(val: string) {
    if (val !== this._messageVisibilityState) {
      this._messageVisibilityState = val;
      this.beginAnimations(this._messageVisibilityState);
    }
  }

  @Input() styleOverides: LinearLoaderStyles;

  public _messageVisibilityState: string = 'hidden';
  @Input() delay: number = 0;
  @Input() duration: number = 2;
}
